import React, { useState, useEffect } from "react";
import "./client.css";

const Client = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const textArray = [
    "“ABC Agency our the best. Not only did they deliver my work on time, they even walked my dog when I was out of town”",
    "“They consistently exceeds my expectations with their top-notch work. Impressive results every time!”",

  ];

  const customer = [
    "A Smith – Neighbour",
    "- Lorrie Danniell",
 
  ];

  useEffect(
    () => {
      const intervalId = setInterval(() => {
        setCurrentIndex((currentIndex + 1) % textArray.length);
        setCurrentIndex((currentIndex + 1) % customer.length);
      }, 5000);
      return () => clearInterval(intervalId);
    },
    [currentIndex, textArray.length],
    [currentIndex, customer.length]
  );

  return (
    <div className="client__container">
      <div className="client__header">
        <h1>
          Our clients <br /> love our work
        </h1>
        <h3> But don’t just take our word for it...</h3>
      </div>
      <div className="client__comment">
        {textArray[currentIndex]} <br />
       <div className="client__name"> {customer[currentIndex]}</div>
      </div>
    </div>
  );
};

//    const words=[
//     {id:0,value:"edwedwd"},
//     {id:1,value:"Mango"},
//     {id:2,value:"Banana"},
//     {id:3,value:"Banana1"},
//     {id:4,value:"Banana2"},
//   ];
//   const [wordData,setWordData]=useState(words[0].value)
//   const handleClick=(index)=>{
//     console.log(index)
//     const wordSlider=words[index].value;
//     setWordData(wordSlider)
//   }

//   return (
//     <div className="main">
//       <div >" {wordData} "</div>
//       <div className='flex_row'>
//         {words.map((data,i)=>
//           <h1 key={i} onClick={()=>handleClick(i)}>.</h1>
//         )}
//       </div>
//     </div>
//   );
// }

export default Client;
